import RecommendationFieldSelect from './recommendation-field-select';

/**
 * "Conocer cuál es el lote más adecuado para X" — the wizard run from the hybrid's side.
 *
 * Entered from product exploration, where the hybrid is already chosen, so it is stored as a
 * management recommendation like the other option on that modal; only the questions differ.
 *
 * A route-level binding rather than a component: the wizard itself is shared, and this is only
 * here so the route table names a component instead of an inline closure.
 */
const FieldForHybridCreate = () => <RecommendationFieldSelect crop='corn' variant='field-for-hybrid' />;

export default FieldForHybridCreate;
